(function () {
  var CORPORATE_GIFT_HANDLES = {
    'harvest-table': true,
    'classic-supper-box': true,
    'the-pantry-packer': true
  };

  function updateCartBadge(itemCount) {
    document.querySelectorAll('#cart-icon-bubble, #mobile-cart-icon-bubble').forEach(function (bubble) {
      bubble.setAttribute('data-value', itemCount);
      var pill = bubble.querySelector('div');
      var span = bubble.querySelector('span');
      if (span) {
        span.textContent = itemCount < 100 ? itemCount : '99+';
      }
      if (pill) {
        pill.classList.toggle('hidden', itemCount === 0);
      }
    });
  }

  function updateCorporateGiftCartState(items) {
    var hasCorporateGift = items.some(function (item) {
      return CORPORATE_GIFT_HANDLES[item.handle] === true;
    });
    document.documentElement.classList.toggle('cart-has-corporate-gift', hasCorporateGift);
  }

  function syncCartBadge() {
    var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';
    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        updateCorporateGiftCartState(cart.items || []);
      })
      .catch(function () {});
  }

  var CART_MUTATION_PATTERN = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartMutation = CART_MUTATION_PATTERN.test(url);
    var promise = originalFetch.apply(this, arguments);
    if (isCartMutation) {
      promise.then(function () { syncCartBadge(); }).catch(function () {});
    }
    return promise;
  };

  var OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var xhr = new OriginalXHR();
    var originalOpen = xhr.open;
    xhr.open = function (method, url) {
      if (CART_MUTATION_PATTERN.test(url)) {
        xhr.addEventListener('loadend', function () { syncCartBadge(); });
      }
      return originalOpen.apply(xhr, arguments);
    };
    return xhr;
  }
  window.XMLHttpRequest = PatchedXHR;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartBadge);
  } else {
    syncCartBadge();
  }
  document.addEventListener('shopify:section:load', syncCartBadge);
  document.addEventListener('eurus:cart:items-changed', syncCartBadge);
})();
